export default __webpack_public_path__ + "static/B0179-aa80212815d9fe2ed4cc28899f0e4cc8.png";